import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import { ROUTES } from '#/config/routes';
import { isAuthEnabled } from '#/config/auth';
import { getAccess } from '#/utils/auth/tokenStorage';

const RootRedirect = () => {
  const access = useSelector((state) => state.infra.access);

  if (!isAuthEnabled) {
    return <Navigate to={ROUTES.home} replace />;
  }

  const isAuthenticated = Boolean(access || getAccess());

  return <Navigate to={isAuthenticated ? ROUTES.home : ROUTES.login} replace />;
};

export default RootRedirect;
